<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      isActive: 0,
      examInfo: {},
      examRow: {}, 
      isread: "",
      PaperMode: "", 
      rowInfo:{},
      type:1,
    };
  },
  components: {
    Page: () => import("./components/page.vue"),
    Details: () => import("./components/details.vue"),
    myDetails: () => import("./components/myDetails.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Page";
          case 1:
          return "Details";
          case 2:
          return "myDetails";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
};
</script>
  